/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

const { wrapRootElement, wrapPageElement } = require('./gatsby-shared')
require('styles/main.css')

exports.wrapRootElement = wrapRootElement
exports.wrapPageElement = wrapPageElement
